import { mergeClassNames } from '@/utils/mergeClassNames';

import styles from './CalibrateLoading.module.css';

import { CustomLoading, CustomLoadingProps } from '../Loading';

export const CalibrateLoading = (props: CustomLoadingProps) => {
  return (
    <CustomLoading
      {...props}
      iconClassName={mergeClassNames(styles.icon, props.iconClassName)}
      leadingIcon='spinner'
      message='Calibrating...'
      size='medium'
    />
  );
};
